// /////////////////////////////////////////////////////////////
// [ファイル] GoogleWorkspacePage.tsx
// [概要] Google Workspace 連携ページ。Genkit 駆動の AI アシスタントで、
//        ログインユーザー本人のカレンダー・ToDo(Tasks)・Keep・Gmail 下書きを
//        会話形式で操作する。
//        ※ カレンダー一覧表示は別ページで検討するため本ページからは撤廃。
// /////////////////////////////////////////////////////////////
import React, { Suspense } from 'react';
import { Box, Typography } from '@mui/material';
import { blueGrey } from '@mui/material/colors';
import * as Icons from '../constants/icons';
import WorkspaceAssistantPanel from '../components/WorkspaceAssistantPanel';
import { AssistantThinkingProvider } from '../providers/AssistantThinkingProvider';

// 背景の波形演出は three.js (約600KB) を含むため遅延読み込みとし、
// このページを開いたときにだけロードする (他ページのバンドルへ影響させない)
const ParticleWaveBackground = React.lazy(
  () => import('../components/ParticleWaveBackground')
);

export default function GoogleWorkspacePage() {
  return (
    // AssistantThinkingProvider で「推論中」状態をページ内に放送し、
    // 背景のコア演出 (購読者) がパネルの推論に合わせて反応できるようにする
    <AssistantThinkingProvider>
    <Box sx={{ p: 0, width: '95%', margin: '0 auto', position: 'relative' }}>
      {/* 背景の波形 (ページ背景色はそのまま、透過キャンバスに波形だけ描画) */}
      <Suspense fallback={null}>
        <ParticleWaveBackground />
      </Suspense>

      {/* 前面コンテンツ (zIndex で波形キャンバスより手前に重ねる) */}
      <Box sx={{ position: 'relative', zIndex: 1 }}>
        {/* ヘッダー */}
        <Box sx={{ px: 1 }}>
          <Typography
            variant="h6"
            sx={{ fontWeight: 700, display: 'flex', alignItems: 'center', gap: 2, color: blueGrey[500] }}
          >
            <Icons.AutoAwesome /> Hozenall Cloud AI エージェント
          </Typography>
          <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
            AI との会話は左の一覧に保存され、よく使う手順は「ルール」「スキル」「ワークフロー」として AI に覚えさせられます
          </Typography>
        </Box>

        {/* AI アシスタント本体 */}
        <WorkspaceAssistantPanel emptyStateAnchor="core" />
      </Box>
    </Box>
    </AssistantThinkingProvider>
  );
}
